// Created on 10/28, the demand is the second generation product
// js/sections/text-swiper.js
import { timeline as timeline1, animate as animate1, inView as inView1 } from "//de.ringconn.com/cdn/shop/t/44/assets/vendor.min.js?v=110209841862038618801780039707";
import { EffectCarousel as EffectCarousel1 } from "//de.ringconn.com/cdn/shop/t/44/assets/theme.js?v=103289958331771147771780039919";
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var TextSwiper = class extends EffectCarousel1 {
  constructor() {
    super();
    if (reduceMotion) {
      inView1(this, this._reveal.bind(this));
    }
  }
  _reveal() {
    animate1(
      this.selectedSlide.querySelector(".blockquote"),
      { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] },
      { duration: 0.5 },
    );
  }
  async _transitionTo(fromSlide, toSlide, options = {}) {
    await timeline1([
      [
        fromSlide.querySelectorAll(".text-swiper__title, .text-swiper__author"),
        { opacity: [null, 0] },
        { duration: 0.5 },
      ],
      [
        fromSlide.querySelector(".blockquote"),
        { opacity: [null, 0], ...(reduceMotion && { transform: [null, "translateY(-10px)"] }) },
        { duration: 0.5, at: "<" },
      ],
    ]).finished;
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    await timeline1([
      [toSlide.querySelectorAll(".text-swiper__title, .text-swiper__author"), { opacity: [0, 1] }, { duration: 0.5 }],
      [
        toSlide.querySelector(".blockquote"),
        { opacity: [0, 1], ...(reduceMotion && { transform: ["translateY(10px)", "translateY(0px)"] }) },
        { duration: 0.5, at: "<" },
      ],
    ]).finished;
  }
};
if (!window.customElements.get("text-swiper")) {
  window.customElements.define("text-swiper", TextSwiper);
}
// Created on 10/28, the demand is the second generation product
// js/sections/product-swiper.js
import { timeline as timeline2, animate as animate2, inView as inView2 } from "//de.ringconn.com/cdn/shop/t/44/assets/vendor.min.js?v=110209841862038618801780039707";
import { EffectCarousel as EffectCarousel2 } from "//de.ringconn.com/cdn/shop/t/44/assets/theme.js?v=103289958331771147771780039919";
var reduceMotion2 = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var ProductSwiper = class extends EffectCarousel2 {
  constructor() {
    super();
    if (reduceMotion2) {
      inView2(this, this._reveal.bind(this));
    }
  }
  _reveal() {
    animate2(
      this.selectedSlide.querySelector(".blockquote"),
      { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] },
      { duration: 0.5 },
    );
  }
  async _transitionTo(fromSlide, toSlide, options = {}) {
    //console.log(this.section, "section");
    await timeline2([
      [fromSlide.querySelectorAll(".product-swiper__logo, .list_images"), { opacity: [null, 0] }, { duration: 0.5 }],
      [
        fromSlide.querySelector(".blockquote"),
        { opacity: [null, 0], ...(reduceMotion2 && { transform: [null, "translateY(-10px)"] }) },
        { duration: 0.5, at: "<" },
      ],
    ]).finished;
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    await timeline2([
      [toSlide.querySelectorAll(".product-swiper__logo, .list_images"), { opacity: [0, 1] }, { duration: 0.5 }],
      [
        toSlide.querySelector(".blockquote"),
        { opacity: [0, 1], ...(reduceMotion2 && { transform: ["translateY(10px)", "translateY(0px)"] }) },
        { duration: 0.5, at: "<" },
      ],
    ]).finished;
  }
};
if (!window.customElements.get("product-swiper")) {
  window.customElements.define("product-swiper", ProductSwiper);
}

import { animate as motionAnimate, timeline as motionTimeline } from "//de.ringconn.com/cdn/shop/t/44/assets/vendor.min.js?v=110209841862038618801780039707";

const reduceDrawerAnimation = window.matchMedia("(prefers-reduced-motion: reduce)").matches || false;
class ActivePopup extends HTMLElement {
  constructor() {
    super();
    this.drawers = new Map();
    this.init();
  }

  init() {
    this.initTriggers();
    this.initDrawers();
  }

  initTriggers() {
    this.querySelectorAll("[data-drawer-trigger]").forEach((trigger) => {
      trigger.addEventListener("click", (e) => this.handleTriggerClick(e));
    });
  }

  initDrawers() {
    this.querySelectorAll("[data-drawer]").forEach((drawer) => {
      this.setupDrawer(drawer);
      this.drawers.set(drawer.dataset.drawer, drawer);
    });
  }

  handleTriggerClick(e) {
    const trigger = e.currentTarget;
    const userId = trigger.dataset.userid;
    if (!userId) {
      window.location.href = "/account/login?activeUrl=/pages/black-friday-event";
      return;
    }
    const drawer = this.querySelector("x-drawer.active-popup-drawer");
    this.openDrawer(drawer);
  }

  setupDrawer(drawer) {
    const closeButton = drawer.querySelector("[data-drawer-close]");
    if (closeButton) {
      closeButton.addEventListener("click", () => this.closeDrawer(drawer));
    }

    drawer.addEventListener("click", (e) => {
      if (e.target === drawer) {
        this.closeDrawer(drawer);
      }
    });

    this.setupForm(drawer);
    this.setInitialState(drawer);
  }

  setupForm(drawer) {
    const form = drawer.querySelector("form.popup-form");
    if (!form) return;

    const marketingCheckbox = form.querySelector('[name="customer.accepts_marketing"]');
    if (marketingCheckbox) {
      marketingCheckbox.setAttribute("data-initial-status", marketingCheckbox.checked.toString());
    }

    this.addEventListener("variant:add", this.handleVariantAdd.bind(this));
    form.addEventListener("submit", (e) => this.handleSubmit(e, drawer));
  }

  setInitialState(drawer) {
    drawer.hidden = true;
    drawer.removeAttribute("open");
  }

  async openDrawer(drawer) {
    if (!drawer) return;

    // Reset initial state
    drawer.hidden = false;
    drawer.removeAttribute("inert");
    drawer.setAttribute("open", "true");

    const content = drawer.shadowRoot.querySelector('[part="content"]');
    if (!content) return;

    // Reset content state
    content.style.opacity = "";
    Array.from(content.children).forEach((child) => {
      child.style.opacity = "";
    });

    // Get the close button
    const closeButton = drawer.shadowRoot.querySelector('[part="outside-close-button"]');
    if (closeButton) {
      closeButton.style.opacity = "";
    }

    // Determine animation based on the drawer's openFrom property
    const openFrom = drawer.getAttribute("open-from") || "right";
    const clipPathProperties = this.getClipPathProperties(openFrom);

    if (reduceDrawerAnimation) {
      await motionAnimate(
        drawer,
        {
          opacity: [0, 1],
          visibility: ["hidden", "visible"],
        },
        {
          duration: 0.2,
        },
      ).finished;
    } else {
      await motionTimeline([
        [drawer, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: clipPathProperties }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
        [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }],
      ]).finished;
    }

    drawer.classList.add("show-close-cursor");
  }

  getClipPathProperties(openFrom) {
    const dir = document.dir;
    switch (openFrom) {
      case "left":
        return dir === "ltr"
          ? ["inset(0 100% 0 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"]
          : ["inset(0 0 0 100% round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
      case "right":
        return dir === "ltr"
          ? ["inset(0 0 0 100% round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"]
          : ["inset(0 100% 0 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
      case "bottom":
        return ["inset(100% 0 0 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
      case "top":
        return ["inset(0 0 100% 0 round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
      default:
        return ["inset(0 0 0 100% round var(--rounded-sm))", "inset(0 0 0 0 round var(--rounded-sm))"];
    }
  }

  async closeDrawer(drawer) {
    if (!drawer) return;

    const content = drawer.shadowRoot.querySelector('[part="content"]');
    const closeButton = drawer.shadowRoot.querySelector('[part="outside-close-button"]');

    if (reduceDrawerAnimation) {
      await motionAnimate(
        drawer,
        {
          opacity: [1, 0],
          visibility: ["visible", "hidden"],
        },
        {
          duration: 0.2,
        },
      ).finished;
    } else if (content && closeButton) {
      const openFrom = drawer.getAttribute("open-from") || "right";
      const clipPathProperties = this.getClipPathProperties(openFrom);

      await motionTimeline([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [content, { clipPath: clipPathProperties.reverse() }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [drawer, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }],
      ]).finished;
    }

    drawer.classList.remove("show-close-cursor");
    this.setDrawerClosed(drawer);
  }

  setDrawerClosed(drawer) {
    drawer.hidden = true;
    drawer.removeAttribute("open");
  }

  setDrawerClosed(drawer) {
    drawer.hidden = true;
    drawer.removeAttribute("open");
  }

  async handleSubmit(e, drawer) {
    e.preventDefault();
    const form = e.target;
    const submitButton = form.querySelector(".popup-form__submit");
    const submitButtonText = submitButton.querySelector(".text");
    const submitButtonLoader = submitButton.querySelector(".button__loader");

    try {
      await this.handleFormSubmission(submitButton, submitButtonText, submitButtonLoader, form, drawer);
    } catch (error) {
      console.error("Submit error:", error);
      this.handleErrors({ message: error.message || "Submission failed, please try again" }, form);
      drawer.setAttribute("open", "");
      drawer.hidden = false;
    } finally {
      await this.resetSubmitButton(submitButton, submitButtonText, submitButtonLoader);
    }
  }

  async handleFormSubmission(submitButton, submitButtonText, submitButtonLoader, form, drawer) {
    await this.setLoadingState(submitButton, submitButtonText, submitButtonLoader);

    const mainFormData = this.getFormData(form);
    const baseUrl = window.ShopifyInfo.baseUrl;

    if (mainFormData.params.length > 0) {
      await this.submitMainForm(mainFormData, baseUrl);
      await this.handleCartOperations(form, submitButton);
    }
    await this.handleMarketingSubscription(form, baseUrl);
    await this.closeDrawer(drawer);
  }

  async setLoadingState(submitButton, submitButtonText, submitButtonLoader) {
    submitButton.disabled = true;
    if (!reduceDrawerAnimation) {
      await motionTimeline([
        [submitButtonText, { opacity: [1, 0] }, { duration: 0.2 }],
        [submitButtonLoader, { opacity: [0, 1] }, { duration: 0.2, at: "<" }],
      ]).finished;
    }
    submitButtonText.hidden = true;
    submitButtonLoader.hidden = false;
  }

  async resetSubmitButton(submitButton, submitButtonText, submitButtonLoader) {
    submitButton.disabled = false;
    if (!reduceDrawerAnimation) {
      submitButtonLoader.style.opacity = 0;
      submitButtonText.hidden = false;
      await motionAnimate(
        submitButtonText,
        { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] },
        { duration: 0.3 },
      ).finished;
    } else {
      submitButtonText.hidden = false;
      submitButtonLoader.hidden = true;
    }
  }

  getFormData(form) {
    const formData = Object.fromEntries(new FormData(form).entries());
    return {
      params: Object.keys(formData)
        .filter((item) => item != "accepts_marketing")
        .map((item) => {
          return {
            propertyKey: item,
            propertyValue: true,
            namespace: "custom",
          };
        }),
      userId: document.querySelector("[data-userid]").dataset.userid,
    };
  }
  async submitMainForm(data, baseUrl) {
    data.webSite = window.ShopifyInfo.webSite || "GB";

    const response = await fetch(`${baseUrl}/admin/shopify/UserModify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ payload: data, client: { languageCode: window?.ShopifyInfo?.language || "en" } }),
    });

    if (!response.ok) throw new Error("Main form submission failed");

    const result = await response.json();
    if (!result?.payload.result) throw new Error("Main form processing failed");
  }

  async handleCartOperations(form, submitButton) {
    const variantId = submitButton.dataset.pid;
    if (!variantId) throw new Error("Product ID not found");
    const cartResponse2 = await fetch(`${Shopify.routes.root}cart.js`);
    const cartContent2 = await cartResponse2.json();

    // 检查购物车中是否已有该商品
    const existingItem = cartContent2.items.find((item) => item.variant_id.toString() === variantId.toString());
    if (existingItem) {
      // 如果已经在购物车中，显示提示信息
      window.location.href = `${Shopify.routes.root}cart`;
      return;
    }
    const formData = new FormData();
    formData.append("form_type", "product");
    formData.append("utf8", "✓");
    formData.append("id", variantId);
    formData.append("quantity", "1");
    formData.append("sections", "variant-added,sections--18458893582589__cart-drawer");
    formData.append("sections_url", `/variants/${variantId}`);
    formData.append("properties[_quantity_limit]", "1");
    formData.append("properties[_quantity_text]", "true");
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: formData,
    });

    const responseJson = await response.json();
    if (!response.ok) throw new Error(responseJson.description || "Failed to add to cart");
    return (window.location.href = `${Shopify.routes.root}cart`);
    if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
      window.location.href = `${Shopify.routes.root}cart`;
      return;
    }

    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
    const cartContent = await cartResponse.json();
    //console.log("cartContent", cartContent);
    cartContent["sections"] = responseJson["sections"];
    this.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent,
        },
      }),
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent,
        },
      }),
    );
  }

  async handleMarketingSubscription(form, baseUrl) {
    const marketingCheckbox = form.querySelector('[name="accepts_marketing"]');
    const currentMarketingStatus = marketingCheckbox?.checked || false;
    const previousMarketingStatus = marketingCheckbox?.getAttribute("data-initial-status") === "true";
    //console.log(currentMarketingStatus, previousMarketingStatus, "previousMarketingStatus");
    if (currentMarketingStatus === previousMarketingStatus) return;

    const customerData = {
      params: [
        {
          propertyKey: "email_marketing_consent.state",
          propertyValue: currentMarketingStatus ? "subscribed" : "unsubscribed",
        },
      ],
      userId: document.querySelector("[data-userid]").dataset.userid,
    };

    const response = await fetch(`${baseUrl}/admin/shopify/UserModifyOrigin`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ payload: customerData, client: { languageCode: window?.ShopifyInfo?.language || "en" } }),
    });

    if (!response.ok) throw new Error("Customer data submission failed");

    const result = await response.json();
    if (!result?.payload.result) throw new Error("Customer data processing failed");
  }

  handleVariantAdd(event) {
    //console.log("Variant added to cart:", event.detail);
  }

  handleErrors(errorData, form) {
    const errorContainer = form.querySelector(".error-message") || this.createErrorContainer(form);
    errorContainer.textContent = errorData.message || "Submission failed, please check inputs and try again";
    errorContainer.hidden = false;

    if (errorData.fields) {
      Object.entries(errorData.fields).forEach(([field, error]) => {
        const input = form.querySelector(`[name="${field}"]`);
        if (input) {
          input.classList.add("error");
          input.setAttribute("aria-invalid", "true");
          input.setAttribute("aria-errormessage", `error-${field}`);
        }
      });
    }
  }

  createErrorContainer(form) {
    const errorContainer = document.createElement("div");
    errorContainer.className = "error-message";
    errorContainer.setAttribute("role", "alert");
    form.insertBefore(errorContainer, form.firstChild);
    return errorContainer;
  }
}

if (!window.customElements.get("active-popup")) {
  window.customElements.define("active-popup", ActivePopup);
}
